import { DASHBOARD_CARD_GUTTER } from '@marvelapp/theme';
export var CARD_WIDTH = 38 * 8;
export var GUTTER = DASHBOARD_CARD_GUTTER;
export var WIDTHS = {
    small: CARD_WIDTH * 2 + GUTTER,
    medium: CARD_WIDTH * 3 + GUTTER * 2,
    large: CARD_WIDTH * 4 + GUTTER * 3,
    extraLarge: CARD_WIDTH * 5 + GUTTER * 4,
    extraExtraLarge: CARD_WIDTH * 6 + GUTTER * 5,
};
export var GWIDTHS = {
    // add side gutters to the breakpoints
    small: WIDTHS.small + GUTTER * 2,
    medium: WIDTHS.medium + GUTTER * 2,
    large: WIDTHS.large + GUTTER * 2,
    extraLarge: WIDTHS.extraLarge + GUTTER * 2,
    extraExtraLarge: WIDTHS.extraExtraLarge + GUTTER * 2,
};
export var PROJECT_GRID_BREAKPOINTS = {
    start: "(max-width: ".concat(GWIDTHS.small, "px)"),
    small: "(min-width: ".concat(GWIDTHS.small + 1, "px) and (max-width: ").concat(GWIDTHS.medium, "px)"),
    medium: "(min-width: ".concat(GWIDTHS.medium + 1, "px) and (max-width: ").concat(GWIDTHS.large, "px)"),
    large: "(min-width: ".concat(GWIDTHS.large + 1, "px) and (max-width: ").concat(GWIDTHS.extraLarge, "px)"),
    extraLarge: "(min-width: ".concat(GWIDTHS.extraLarge + 1, "px) and (max-width: ").concat(GWIDTHS.extraExtraLarge, "px)"),
    extraExtraLarge: "(min-width: ".concat(GWIDTHS.extraExtraLarge + 1, "px)"),
};
